import {
  fetchV1Journals,
  fetchV1AccountJournals,
  createV1Journal,
} from "@/services/v1/accountAPIService";

export default {
  state: {
    journals: [],
    journalPageSize: 5,
    totalJournalCount: 0,
  },
  getters: {
    journals: (state) => state.journals,
    currentJournalPageSize: (state) => state.journalPageSize,
    totalJournalCount: (state) => state.totalJournalCount,
  },
  mutations: {
    SET_JOURNALS(state, journals) {
      state.journals = journals;
    },
    SET_JOURNAL_PAGE_SIZE(state, pageSize) {
      state.journalPageSize = pageSize;
    },
    SET_TOTAL_JOURNAL_COUNT(state, count) {
      state.totalJournalCount = count;
    },
  },
  actions: {
    async fetchJournals(
      { commit },
      { page = 1, pageSize = 5, transaction_type = "" } = {}
    ) {
      //   commit("SET_LOADING", true);
      try {
        const response = await fetchV1Journals(
          page,
          pageSize,
          transaction_type
        );
        commit("SET_JOURNALS", response.results);
        commit("SET_JOURNAL_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_JOURNAL_COUNT", response.count);
      } catch (error) {
        console.error("Error fetching Journals:", error);
      } finally {
        // commit("SET_LOADING", false);
        console.log("finally...");
      }
    },
    async fetchAccountJournals(
      { commit },
      { accountCode = null, page = 1, pageSize = 5 } = {}
    ) {
      //   commit("SET_LOADING", true);
      try {
        const response = await fetchV1AccountJournals(
          page,
          pageSize,
          accountCode
        );
        commit("SET_JOURNALS", response.results);
        commit("SET_JOURNAL_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_JOURNAL_COUNT", response.count);
      } catch (error) {
        console.error("Error fetching account journals:", error);
      } finally {
        // commit("SET_LOADING", false);
        console.log("finally...");
      }
    },
    async addJournal({ commit }, jorunal) {
      try {
        const response = await createV1Journal(jorunal);
        if (response.error) {
          const errorMessages = [];
          errorMessages.push(response.message);
          // commit("SET_ERROR", errorMessages);
          return { success: false, message: response.message };
        }
        return { success: true, data: response };
      } catch (error) {
        const errorMessages = [];
        for (const [key, value] of Object.entries(error.response.data)) {
          errorMessages.push(value[0]);
          console.log(`journal create... ${key}: ${value}`);
        }
        commit("SET_ERROR", errorMessages);
        const message =
          error.response?.data?.message || "Failed to add Journal.";
        return { success: false, message };
      }
    },
  },
};
